document.addEventListener("DOMContentLoaded", () => {
  const selectedCity = localStorage.getItem('selectedCity') || 'RIYADH';
  if(selectedCity.trim() == "DOHA") {
    const mainVariants = document.querySelectorAll('.product-form__main__Var.firstOption input[type="radio"]')
    /*
    if(mainVariants) {
      mainVariants.forEach(input => {
        const value = input.getAttribute('value')
        if(value != "Nice") {
          input.disabled = true
          input.classList.add('unavailable-at-doha')
        }
      })
    } */
    const adonCakeToggles = document.querySelectorAll('.ingredients_toggle')
    if(adonCakeToggles) {
      adonCakeToggles.forEach(input => {
        input.disabled = true

        const label = input.closest('label')
        if(label) {
          label.addEventListener('click', () => {
            window.dispatchEvent(new Event('city-lock:trigger', {bubbles: true, composed: true}));
          })
        }
      })
    }
  }
})

class AvailabilityModal extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.closeButton = this.querySelector('.modal__close');
  }
  connectedCallback() {

    // Add event listener for the close button
    const closeButton = this.querySelector('.modal__close');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.close());
    }

    window.addEventListener('city-lock:trigger', () => {
      this.open()
    })
  }

  // Method to open the modal
  open() {
    this.modal.classList.add('modal--active');
  }

  // Method to close the modal
  close() {
    this.modal.classList.remove('modal--active');
  }
}

customElements.define('availability-modal', AvailabilityModal);